export const Pie_Chart_Data: Highcharts.Options = {
  chart: {
    backgroundColor: 'rgba(30, 34, 37, 0.04)',
    plotBorderWidth: undefined,
    plotShadow: false,
    type: 'pie',
    width: 200,
    height: 130,
    margin: 0,
    marginRight: 105,
  },
  title: {
    text: '',
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
  },
  accessibility: {
    point: {
    },
  },
  plotOptions: {
    pie: {
      cursor: 'pointer',
      dataLabels: {
        enabled: false,
      },
      showInLegend: true,
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    layout: 'vertical',
    align: 'right',
    labelFormat: '{name} {y:.0f}%',
    x: 10,
    y: -15,
    itemStyle: { fontSize: '6px' },
    itemMarginTop: 4,
  },
  series: [
    {
      name: 'Pie',
      type: 'pie',
      data: [],
    },
  ],
};
